/**
 *  区划相关 API 地址
 *  @swagger 
 */
import { IAjaxConfig } from "../libraries"
export class EnumApiRegionorgsvr {
    /**
     * @dec 获取省份
     * @method get
     */
    readonly regionorg_get_provinces: IAjaxConfig = {
        url: '/api/gateway/fis-regionorg/v1/provinces',
        method: 'get',
        loading: true,
        awaitAuthenticated: false,
    };
    /**
     * @dec 获取城市
     * @method get
     */
    readonly regionorg_get_citys: IAjaxConfig = {
        url: '/api/gateway/fis-regionorg/v1/provinces/{provincecode}/cities',
        method: 'get',
        loading: true,
        awaitAuthenticated: false,
    };
    /**
     * @dec 获取区县、街道
     * @method get
     */
    readonly regionorg_get_district: IAjaxConfig = {
        url: '/api/gateway/fis-regionorg/v1/provinces/{provincecode}/cities/{citycode}/districts',
        method: 'get',
        loading: true,
        awaitAuthenticated: false,
    };
}